
import Vue from 'vue'

export default Vue.extend({
  name: 'BoxSvg',
  props: {
    color: {
      required: false,
      default: 'currentColor',
      type: String,
    },
  },
})
